import { NumberInput, required, SimpleForm } from "react-admin";
import { FieldValues } from "react-hook-form";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import { validatePlanningTime } from "shared/utils/validations";

import SiteWithPendingSynchronizationAutocomplete from "../../shared/SiteWithPendingSynchronizationAutocomplete";
import { initialFormValidation, initialNumericFields } from "./config/initialFormFields";

export interface InitialFormProps {
  onSubmit: (data: FieldValues) => void;
}

const formGridSx = {
  "& .MuiStack-root": {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 2,
  },
};

const TestFcrRteInitialForm = ({ onSubmit }: InitialFormProps) => {
  return (
    <SimpleForm onSubmit={onSubmit} mode="onBlur" sx={formGridSx}>
      <SiteWithPendingSynchronizationAutocomplete />

      <CustomDateTimeInput
        source="startingDate"
        validate={[required(), validatePlanningTime]}
        parse={(value) => new Date(value)}
        minDateTime={new Date()}
      />

      {initialNumericFields.map(({ source, defaultValue, label }) => (
        <NumberInput
          key={source}
          source={source}
          defaultValue={defaultValue}
          validate={initialFormValidation.number}
          label={label}
        />
      ))}
    </SimpleForm>
  );
};

export default TestFcrRteInitialForm;
